import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";
import { Colors } from "../../../styles/constant";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import "./RaiseABug.scss";
import SuccessGif from "../../../assets/gif/Success.json";
import CommonGifAnimation from "../../../components/CustomGifAnimation/CommonGifAnimation";
import {
  T_AnimationData,
  T_ApiResponse,
} from "../../../globalTypes/GlobalTypes";
import screenShotIcon from "../../../assets/icons/screenshot-icon.svg";
import {
  getFileSize,
  getModuleNameFromPath,
  handlePermissionMessage,
} from "../../../utils/helper";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import useWindowSize from "../../../hooks/useWindowSize";
import {
  GTAScreenType,
  ModuleNameKey,
  pathToModuleName,
  SCREEN_TYPE,
  tabViewPoint,
} from "../../../utils/constants";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { useLazyRaiseABugDocUploadQuery } from "../GeneralAppElements_Api";
import useDeviceDetection from "../../../hooks/useDeviceDetection";
import { useDispatch } from "react-redux";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import AlertRhombus from "../../../assets/icons/alert-rhombus.svg";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import TriggerGTAEvent from "../../../utils/GTA";
import CustomAppPermissionAlert from "../../../components/CustomAppPermissionAlert/CustomAppPermissionAlert";
import { isEmpty } from "lodash";
import UploadedIcon from "../../../assets/icons/UploadIcon.svg";
import UploadIcon from "../../../assets/icons/upload-doc-icon.svg";
import { nativeCallBackMethodForCamera } from "../../../utils/NativeAppEvents";
import { T_Update_App_Permission_Request } from "../GeneralAppElements_Types";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import { useLazyUpdateAppPermissionQuery } from "../../Feature_GeneralAppElements/GeneralAppElements_Api";
import { setAppPermission } from "../GeneralAppElements_Slice";
import CameraUploadIcon from "../../../assets/icons/camera-upload-icon.svg";
import CameraUploadedIcon from "../../../assets/icons/camera-uploaded-icon.svg";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import { useSaveUIException } from "../../../hooks/useSaveUIException";
import { useAppTranslation } from "../../../hooks/useAppTranslation";
declare const window: any;

interface RaiseABugProps {
  showRaiseABug: boolean;
  handleComponent: (show: boolean) => void;
}

interface RaiseABugReqObject {
  csUserId: string;
  mobile: string;
  lob: string;
  category: string;
  description: string;
  pendingWith: string;
  reportedFrom: string;
}

const RaiseABug: React.FC<RaiseABugProps> = ({
  showRaiseABug,
  handleComponent,
}) => {
  const cameraRef = useRef<HTMLInputElement | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null); // Type the ref explicitly
  const [isCameraPermissionAllowed, setIsCameraPermissionAllowed] =
    useState(false);
  const dispatch = useDispatch();
  const [updateAppPermission] = useLazyUpdateAppPermissionQuery();
  const appDispatch = useAppDispatch();
  const { t } = useAppTranslation("common");

  const [popupOpen, setPopupOpen] = useState(false);
  const [problemText, setProblemText] = useState<string>("");
  const [helperTextProblemText, setHelperTextProblemText] =
    useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const deviceTypeValue = useDeviceDetection();
  const { width } = useWindowSize();

  const MAX_FILE_SIZE_MB = 5;
  const { triggerSaveUIException } = useSaveUIException();
  const [raiseABugDocUploadApi] = useLazyRaiseABugDocUploadQuery();

  const customerAndLobDetails = useAppSelector(
    (state) => state.CsAppSlice.userDetails,
  );

  const [openAlert, setOpenAlert] = useState<boolean>(false);

  const permissionDetails = useAppSelector(
    (state) => state.GeneralAppElementsSlice.appPermission,
  );
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  // const isStorageAccessAllowed = permissionDetails?.permissions.storage || isEmpty(csAppSlice.NativeDeviceInfo?.deviceName);

  const handleCleverTapnGTMCTAClick = (
    type: string,
    FormFieldTitle?: string,
    FormFieldValue?: string,
  ) => {
    if (type === "formfield") {
      triggerCleverTapEvent("serv_raise_bug_form_field", {
        ScreenName: "Servicing Raise A Bug Screen",
        ScreenType: SCREEN_TYPE.generalAppType,
        isPrevPageNameRequired: true,
        FormFieldTitle: FormFieldTitle,
        FormFieldValue: FormFieldValue,
      });
      TriggerGTAEvent("serv_raise_bug_form_field", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_raise_a_bug_screen",
        field_placeholder_text: FormFieldTitle,
        field_placeholder_value: FormFieldValue,
      });
    } else if (type === "Proceed Now") {
      triggerCleverTapEvent("serv_raise_bug_cta_click", {
        ScreenName: "Servicing Raise A Bug Screen",
        ScreenType: SCREEN_TYPE.generalAppType,
        isPrevPageNameRequired: true,
        ctaText: type,
      });
      TriggerGTAEvent("serv_raise_bug_cta_click", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_raise_a_bug_screen",
        CTA_text: type,
      });
    } else if (type === "Upload") {
      triggerCleverTapEvent("serv_raise_bug_cta_click", {
        ScreenName: "Servicing Raise A Bug Screen",
        ScreenType: SCREEN_TYPE.generalAppType,
        isPrevPageNameRequired: true,
        ctaText: type,
        CardTitle: FormFieldTitle,
      });
      TriggerGTAEvent("serv_raise_bug_doc_upload", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_raise_a_bug_screen",
        CTA_text: type,
        card_title: FormFieldTitle,
      });
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const problemTextValue = event.target.value;
    if (problemTextValue.length <= 500) {
      setProblemText(problemTextValue);
      handleCleverTapnGTMCTAClick(
        "formfield",
        "Specify your problem",
        problemText,
      );
    }
    setHelperTextProblemText("");
  };

  const getFileExtension = (filename: string): string => {
    const parts = filename.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1].toUpperCase();
    }
    return "";
  };

  const cameraPermissionMessageHandler = (event: CustomEvent) => {
    handlePermissionMessage(
      event,
      "Camera",
      setIsCameraPermissionAllowed, // Assuming this is a state setter function
      callPermissionApi, // Assuming this is the function to call your API
    );
  };

  const cameraPermissionUpdateMessageHandler = (event: CustomEvent) => {
    console.log(
      "Camera Permission Message Update from React Native Android: ",
      event.detail,
    );
    // Handle the incoming message
    const cameraPermissionInfo = event.detail === "true" ? true : false;
    console.log("Camera Permission ", cameraPermissionInfo);
    setIsCameraPermissionAllowed(cameraPermissionInfo);
    setTimeout(() => {
      if (cameraPermissionInfo && cameraRef.current) {
        console.log("within Loop under");
        //cameraRef.current.value = ''; // Clear previous value
        //cameraRef?.current?.click();    // Programmatically open the file input
        if (fileInputRef.current) {
          console.log("if", cameraRef);
          fileInputRef.current.click(); // Programmatically trigger the file input
        }
      }
      callPermissionApi("camera", cameraPermissionInfo);
    }, 1000);
  };

  useEffect(() => {
    console.log("use effect is calling");
    fetchCameraPermissionStatus();

    window.addEventListener(
      "fetch_camera_permission_status",
      cameraPermissionMessageHandler,
    );
    window.addEventListener(
      "fetch_camera_permission_update_status",
      cameraPermissionUpdateMessageHandler,
    );

    return () => {
      window.removeEventListener(
        "fetch_camera_permission_status",
        cameraPermissionMessageHandler,
      );
      window.removeEventListener(
        "fetch_camera_permission_update_status",
        cameraPermissionUpdateMessageHandler,
      );
    };
  }, []);

  useEffect(() => {
    nativeCallBackMethodForCamera({
      type: "getCameraPermissionInfo",
      isGrant: "false",
    })
      .then((response: any) => {
        console.log("Response from native code:", response);
        const cameraPermissionInfo = response.isPermissionEnabled;
        console.log("Camera Permission ", cameraPermissionInfo);
        setIsCameraPermissionAllowed(cameraPermissionInfo);
        callPermissionApi("camera", cameraPermissionInfo);
      })
      .catch((error) => {
        const currentPath = window?.location?.pathname;
        triggerSaveUIException({
          moduleName: getModuleNameFromPath(currentPath),
          pageName: currentPath || "",
          statusCode: 500,
          uiDisplayMessage: `fileName-AppSwitchHeader and function - nativeCallBackMethod() `,
          errorMessage: {
            stk: error.stack || "No stack available",
            msg: error.message || "Unknown error occurred",
          },
        });
      });
  }, []);

  const fetchCameraPermissionStatus = () => {
    const message = {
      action: "FETCH_CAMERA_PERMISSION_STATUS",
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message),
      );
    }
  };

  const updateCameraPermissionAndroid = () => {
    const message = {
      action: "UPDATE_CAMERA_PERMISSION_FROM_USER_ACTION",
    };
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
      console.log(
        "Sending event to TWA React Native Android " + JSON.stringify(message),
      );
    }
  };

  const callPermissionApi = async (name: string, permissionValue: any) => {
    let request = {
      mobileNumber: csAppSlice.userDetails?.mobileNumber,
      csUserId: csAppSlice.userDetails?.CS_USER_ID,
      permissions: {
        ...permissionDetails?.permissions,
        [name]: permissionValue,
      },
    };

    const payload = request as T_Update_App_Permission_Request;
    const response = await updateAppPermission(payload);
    if (response.data?.code === API_STATUS_CODE.SUCCESS) {
      let res = response.data?.payload;
      let updatePermissionData: T_Update_App_Permission_Request = {
        csUserId: res.csUserId,
        mobileNumber: res.mobileNumber,
        permissions: {
          tncConsent: res.tncConsent || false,
          privacyConsent: res.privacyConsent || false,
          whatsapp: res.whatsappConsent || false,
          camera: res.cameraPermission || false,
          notifications: res.notificationsPermission || false,
          contact: res.contactsPermission || false,
          call: res.callLogsPermission || false,
          sms: res.messagesPermission || false,
          location: res.locationEnabled || false,
          storage: res.storageEnabled || false,
          displayOverOtherApps: res.displayOverOtherAppsEnabled || false,
        },
      };
      appDispatch(setAppPermission(updatePermissionData));
    } else {
      appDispatch(
        setError({
          error: response.error as T_ApiResponse<any>,
          message: "failed",
        }),
      );
    }
  };

  const onCameraClick = () => {
    console.log("Camera Click!!!", isCameraPermissionAllowed);
    //setUserCameraClick(true);
    if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
      console.log("Android Camera");
      if (isCameraPermissionAllowed) {
        console.log("within Loop");
        return;
      } else {
        updateCameraPermissionAndroid();
      }
    } else {
      nativeCallBackMethodForCamera({
        type: "getCameraPermissionInfo",
        isGrant: "false",
      })
        .then((response: any) => {
          console.log("Response from native code:", response);
          const cameraPermissionInfo = response.isPermissionEnabled;
          setIsCameraPermissionAllowed(cameraPermissionInfo);

          if (cameraPermissionInfo) {
            console.log("within ios Loop");
            if (fileInputRef.current) {
              console.log("if", cameraRef);
              fileInputRef.current.click(); // Programmatically trigger the file input
            }
            //return;
          } else {
            nativeCallBackMethodForCamera({
              type: "askCameraPermission",
              isGrant: "true",
            })
              .then((response: any) => {
                console.log("Response from native code:", response);
                const cameraPermissionInf =
                  response.isGranted === "granted" ? true : false;
                if (cameraPermissionInf) {
                  if (fileInputRef.current) {
                    console.log("if", cameraRef);
                    fileInputRef.current.click(); // Programmatically trigger the file input
                  }
                }
                setIsCameraPermissionAllowed(cameraPermissionInf);
                callPermissionApi("camera", cameraPermissionInf);
              })
              .catch((error) => {
                const currentPath = window?.location?.pathname;
                triggerSaveUIException({
                  moduleName: getModuleNameFromPath(currentPath),
                  pageName: currentPath || "",
                  statusCode: 500,
                  uiDisplayMessage: `fileName(RaiseABug) and functionName(nativeCallBackMethodForCamera) `,
                  errorMessage: {
                    stk: error.stack || "No stack available",
                    msg: error.message || "Unknown error occurred",
                  },
                });
              });
          }
        })
        .catch((error) => {
          const currentPath = window?.location?.pathname;
          triggerSaveUIException({
            moduleName: getModuleNameFromPath(currentPath),
            pageName: currentPath || "",
            statusCode: 500,
            uiDisplayMessage: `fileName(RaiseABug) and functionName(nativeCallBackMethodForCamera) `,
            errorMessage: {
              stk: error.stack || "No stack available",
              msg: error.message || "Unknown error occurred",
            },
          });
        });
    }
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleCleverTapnGTMCTAClick("Upload", "Upload screenshot");
    const file = event.target.files?.[0];
    if (file?.name) {
      if (
        !["image/jpg", "image/jpeg", "image/png", "application/pdf"].includes(
          file?.type,
        )
      ) {
        return alert(`File type ${file?.type} not supported`);
      }
      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        alert(`File size exceeds ${MAX_FILE_SIZE_MB} MB limit.`);
        setSelectedFile(null);
      } else {
        setSelectedFile(file);
      }
      event.target.value = "";
    }
  };

  const handleDeleteFile = () => {
    setSelectedFile(null);
  };

  let raiseABugReq: RaiseABugReqObject = {
    csUserId: customerAndLobDetails?.CS_USER_ID
      ? customerAndLobDetails?.CS_USER_ID
      : "user123",
    mobile: customerAndLobDetails?.customerAndLobDetails
      ? customerAndLobDetails?.customerAndLobDetails[0]?.MOBILE
      : "",
    lob: customerAndLobDetails?.customerAndLobDetails
      ? customerAndLobDetails?.customerAndLobDetails[0]?.LOBID
      : "LI",
    category: "Bug",
    description: problemText || "",
    pendingWith: "",
    reportedFrom: deviceTypeValue || "ABFSLLI",
  };

  const handleProceed = async () => {
    handleCleverTapnGTMCTAClick("Proceed Now");

    const formData = new FormData();
    if (selectedFile) {
      formData.append("file", selectedFile || "");
    }
    formData.append(
      "serviceRequest",
      new Blob([JSON.stringify(raiseABugReq)], {
        type: "application/json",
      }),
    );

    try {
      setShowLoading(true);
      const response = await raiseABugDocUploadApi(formData);
      if (
        response.data?.payload &&
        response.data?.code === API_STATUS_CODE.SUCCESS
      ) {
        setShowLoading(false);
        setPopupOpen(true);
        triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
          ScreenName: CT_ScreenEvntDtls.R_GAE.gaConcernSubSuccess.screenName,
          ScreenType: SCREEN_TYPE.DashboardScreenType,
        });
        setProblemText("");
        setSelectedFile(null);
      } else {
        dispatch(
          setError({
            error: (response.error as T_ApiResponse<any>) || new Error(),
            message: "Raise a Bug api failed!!",
          }),
        );
        setShowLoading(false);
        setPopupOpen(false);
      }
    } catch (error) {}
  };
  const successCustomPopupChildren = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          marginLeft: "1rem",
          marginRight: "1rem",
          marginBottom: "2rem",
        }}
      >
        <CommonGifAnimation
          animationData={SuccessGif as T_AnimationData}
          width="15.625rem"
        />
        <Typography variant="h3" marginBottom=".625rem">
          {t("raiseABug.success.title")}
        </Typography>
        <Typography variant="subtitle2">
          {t("raiseABug.success.subtitle")}
        </Typography>
      </Box>
    );
  };

  useEffect(() => {
    if (showRaiseABug) {
      triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
        ScreenName: CT_ScreenEvntDtls.R_GAE.gaRaiseaBug.screenName,
        ScreenType: SCREEN_TYPE.DashboardScreenType,
      });
    }
    if (!showRaiseABug) {
      setProblemText("");
      setSelectedFile(null);
    }
  }, [showRaiseABug]);

  const handleClose = () => {
    handleComponent(false);
    setHelperTextProblemText("");
  };

  // const isButtonDisabled = !selectedFile === null || problemText.length < 50;

  const isButtonDisabled = !(problemText.length >= 5);

  const handleSuccessPopUpClose = () => {
    setPopupOpen(false);
    handleClose();
  };

  return (
    <>
      {!popupOpen ? (
        <CustomPopup
          open={showRaiseABug}
          handleOpen={handleClose}
          btnLabel={t("raiseABug.goBack")}
          btnStartIcon={
            <ChevronLeftIcon fontSize="small" sx={{ color: Colors.red }} />
          }
          className={`raise-a-bug-popup ${
            width < tabViewPoint ? "mobile-view" : "web-view"
          } `}
        >
          <Box className="raise-a-bug-box">
            <Typography
              variant="h5"
              letterSpacing=".0938rem"
              textAlign="center"
              marginBottom="1.5rem"
            >
              {t("raiseABug.title")}
            </Typography>

            <TextField
              multiline
              fullWidth
              rows={4}
              placeholder={t("raiseABug.inputPlaceHolder")}
              value={problemText}
              className="raise-bug-text-area"
              onChange={handleChange}
              inputProps={{
                maxLength: 500,
                inputMode: "text",
              }}
              error={helperTextProblemText.length > 0}
              helperText={
                <span style={{ display: "flex", alignItems: "center" }}>
                  <InputAdornment position="start">
                    {helperTextProblemText.length > 0 && (
                      <img src={AlertRhombus} />
                    )}
                  </InputAdornment>
                  {helperTextProblemText}
                </span>
              }
            />
            <Box
              sx={{
                border: ".0625rem dashed #D5D7DE",
                background: Colors.bgGray,
                borderRadius: "1.5rem",
              }}
              width="100%"
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                margin="1rem"
              >
                <Box>
                  <Typography variant="h5" fontWeight={700}>
                    {t("raiseABug.uploadTitle")}
                  </Typography>
                  <Typography
                    variant="h6"
                    marginTop="0.5rem"
                    color={"#000000B2"}
                  >
                    {t("raiseABug.uploadType")}
                  </Typography>
                </Box>
                <Box display="flex">
                  {csAppSlice.NativeDeviceInfo?.deviceName && (
                    <Box>
                      <Button
                        component="label"
                        variant="text"
                        startIcon={
                          <img
                            src={
                              selectedFile?.name
                                ? CameraUploadedIcon
                                : CameraUploadIcon
                            }
                          />
                        }
                        htmlFor={
                          isCameraPermissionAllowed ? "upload-image" : ""
                        }
                        className="upload-button"
                        onClick={onCameraClick}
                      >
                        <input
                          //key={fileInputKey}
                          ref={cameraRef}
                          style={{ display: "none" }}
                          id="upload-image"
                          hidden
                          accept="image/jpeg, image/png"
                          type="file"
                          multiple={false}
                          onChange={handleFileUpload}
                          capture="environment"
                        />
                        <Typography
                          fontSize={10}
                          fontWeight={600}
                          color={Colors.descriptionGray}
                          textAlign="center"
                          lineHeight=".75rem"
                          marginTop=".5rem"
                        >
                          Camera
                        </Typography>
                      </Button>
                    </Box>
                  )}
                  <Box>
                    <input
                      //key={fileInputKey}
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      id="upload-image"
                      hidden
                      accept="image/jpeg, image/png"
                      type="file"
                      multiple={false}
                      onChange={handleFileUpload}
                      capture="environment"
                    />
                  </Box>
                  <Box>
                    <Button
                      component="label"
                      variant="text"
                      startIcon={
                        <img
                          src={selectedFile?.name ? UploadedIcon : UploadIcon}
                        />
                      }
                      htmlFor="upload-images"
                      className="upload-button"
                    >
                      <input
                        style={{ display: "none" }}
                        id="upload-images"
                        hidden
                        accept="image/jpeg, image/png, application/pdf"
                        type="file"
                        multiple={false}
                        onChange={handleFileUpload}
                      />
                      <Typography
                        fontWeight={600}
                        fontSize={10}
                        color={Colors.descriptionGray}
                        lineHeight=".75rem"
                        textAlign="center"
                        marginTop=".5rem"
                      >
                        {t("raiseABug.upload")}
                      </Typography>
                    </Button>
                    {/* {
                    isStorageAccessAllowed ?
                    <Button
                    component="label"
                    variant="text"
                    startIcon={<img src={UploadIcon} />}
                    htmlFor="upload-image"
                    className="upload-button"
                  >
                    <input
                      style={{ display: "none" }}
                      id="upload-image"
                      hidden
                      accept="image/jpeg, image/png, application/pdf"
                      type="file"
                      multiple={false}
                      onChange={handleFileUpload}
                    />
                    <Typography
                      fontFamily="Poppins"
                      fontWeight={600}
                      fontSize=".625rem"
                      lineHeight=".9375rem"
                      textAlign="center"
                      color="#797979"
                      marginTop=".5rem"
                    >
                      Upload
                    </Typography>
                  </Button> :
                  <Button
                  component="label"
                  variant="text"
                  startIcon={<img src={UploadIcon} />}
                  className="upload-button"
                  onClick={()=>setOpenAlert(true)}
                >
                  <Typography
                    fontFamily="Poppins"
                    fontWeight={600}
                    fontSize=".625rem"
                    lineHeight=".9375rem"
                    textAlign="center"
                    color="#797979"
                    marginTop=".5rem"
                  >
                    Upload
                  </Typography>
                </Button>
                  } */}
                  </Box>
                </Box>
              </Box>
            </Box>
            <Typography
              color="#9E9E9E"
              variant="h6"
              fontWeight={500}
              marginTop=".5rem"
              marginBottom="1.5rem"
              marginRight="auto"
            >
              {t("raiseABug.disclaimer")}
            </Typography>
            {selectedFile && (
              <Box width="100%">
                <Typography
                  variant="h5"
                  lineHeight="1.3125rem"
                  marginBottom=".5rem"
                >
                  {t("raiseABug.uploads")}:
                </Typography>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  marginBottom="1.5rem"
                  sx={{
                    backgroundColor: "#F7F7F7",
                    borderRadius: "1.5rem",
                    padding: ".75rem 1rem",
                  }}
                >
                  <Box display="flex" alignItems="center" gap=".5rem">
                    <Box className="upload-file-icon-wrapper">
                      <img src={screenShotIcon} alt="screenshot" />
                    </Box>
                    <Box>
                      <Typography
                        variant="h5"
                        fontWeight={700}
                        fontFamily="Poppins"
                        sx={{ wordBreak: "break-all" }}
                      >
                        {selectedFile.name.split(".")[0]}
                      </Typography>
                      <Typography
                        variant="h6"
                        lineHeight="1.125rem"
                        color="#797979"
                      >
                        {getFileExtension(selectedFile.name)}
                      </Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="center" gap=".625rem">
                    <Typography variant="h6">
                      {getFileSize(selectedFile)}
                    </Typography>
                    <IconButton
                      onClick={handleDeleteFile}
                      color="inherit"
                      size="small"
                      sx={{ color: "#D04A02", padding: 0, cursor: "pointer" }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            )}
            {showLoading ? (
              <CustomThreeDotsLoader />
            ) : (
              <Button
                variant="contained"
                fullWidth
                onClick={handleProceed}
                sx={{
                  borderRadius: "4.25rem",
                  padding: "1rem 2.625rem",
                  margin: "0 auto", // Center the button horizontally
                  display: "flex",
                  justifyContent: "center",
                }}
                // disabled={problemText.length < 50}
                disabled={isButtonDisabled}
              >
                {t("raiseABug.proceedNow")}
              </Button>
            )}
          </Box>
        </CustomPopup>
      ) : (
        <CustomPopup
          open={popupOpen}
          handleOpen={handleSuccessPopUpClose}
          btnLabel={t("raiseABug.goBack")}
          btnStartIcon={
            <ChevronLeftIcon fontSize="small" sx={{ color: Colors.red }} />
          }
          className={`success-reportBug-popup ${
            width < tabViewPoint ? "mobile-view" : "web-view"
          }`}
        >
          {successCustomPopupChildren()}
        </CustomPopup>
      )}
      {
        <CustomAppPermissionAlert
          handleClose={() => {
            setOpenAlert(false);
          }}
          open={openAlert}
        />
      }
    </>
  );
};

export default RaiseABug;
